import Vue from 'vue';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import router from './router';
import VueLogger from 'vuejs-logger';
import VuetifyToast from 'vuetify-toast-snackbar-ng';

Vue.config.productionTip = false

Vue.use(VuetifyToast, {
	x: 'right', // default
	y: 'bottom', // default
	color: 'info', // default
	icon: 'info',
	iconColor: '', // default
	classes: [
		'body-2'
	],
	timeout: 3000, // default
	dismissable: true, // default
	multiLine: false, // default
	vertical: false, // default
	queueable: true, // default
	showClose: false, // default
	closeText: '', // default
	closeIcon: 'close', // default
	closeColor: '', // default
	slot: [], //default
	shorts: {
		custom: {
			color: 'purple'
		}
	},
	property: '$toast' // default
});

Vue.use(VueLogger, {
  isEnabled: true,
  logLevel: 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true,
});

Vue.config.errorHandler = (err, vm, info) => {
	// err: error trace
	// vm: component in which error occured
	// info: Vue specific error information such as lifecycle hooks, events etc.

	let handler, current = vm
	if (vm.$options.errorHandler) {
		handler = vm.$options.errorHandler
	} else {
		while (current.$parent) {
			current = current.$parent
			if (handler = current.$options.errorHandler) break
		}
	}
	if (handler) handler.call(current, err, vm, info)
};

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
